import { Box, Switch, Typography } from "@mui/material";
import React from "react";

const LeaveBalanceUpdate = ({
                                  newAddOnSettings,
                                  setNewAddOnSettings,
  disabled = false,
                                }: {
  newAddOnSettings: any;
  setNewAddOnSettings: any;
  disabled: boolean;
}) => {
  return (
    <Box
      sx={{
        marginTop: "20px",
        marginBottom: "8px",
        borderRadius: "8px",
        border: 1,
        borderWidth: "1px",
        borderColor: "rgba(0,0,0,0.12)",
        background: "#FFF",
        padding: "16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0px 16px",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontWeight: 400,
              fontSize: "16px",
              color: "rgba(0, 0, 0, 0.87)",
            }}
          >
            Allow HR Managers to Update Time Off Balance for Workers
          </Typography>
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontWeight: 400,
              fontSize: "12px",
              color: "rgba(0, 0, 0, 0.6)",
            }}
          >
            When enabled, HR Managers can update the balance of time off for workers
          </Typography>
        </Box>
        <Switch
          checked={newAddOnSettings.leaveBalanceUpdateEnabled ?? false}
          disabled={disabled}
          onChange={(e) => {
            setNewAddOnSettings((pre: any) => {
              return {
                ...pre,
                leaveBalanceUpdateEnabled: e.target.checked,
              };
            });
          }}
        />
      </Box>
    </Box>
  );
};

export default LeaveBalanceUpdate;
